<tt-card>
    <tt-file-uploader (ttFilesChange)="onFilesChanged($event)" ttMultiple="false" ttDropZone></tt-file-uploader>
    <div [hidden]="!hasSpreadsheet" [ngClass]="{ 'tt-spreadsheet__hide-toolbar': ttHideToolbar, 'tt-spreadsheet__hide-actionbar': ttHideActionbar, 'tt-spreadsheet__hide-sheetsbar': ttHideSheetsbar }">
        <kendo-spreadsheet (change)="onSpreadsheetChanged($event)" (activeSheetChange)="onSpreadsheetChanged($event)"></kendo-spreadsheet>
    </div>
    <ng-container *ngIf="!!jsonData">
        <tt-select ttLabel="encoding" [(ttModel)]="selectedEncoding" (ttModelChange)="onEncodingChanged($event)" [ttData]="encodings"></tt-select>
        <tt-textarea ttLabel="filecontent" [(ttModel)]="jsonData" ttReadonly></tt-textarea>
    </ng-container>
    <tt-toast *ngIf="!hasSpreadsheet && !jsonData" class="col-xs-6 sp-0" ttTitle="no_file_selected" ttMessage="select_a_file_to_view_data" style="max-width: 40rem; width: 100%"></tt-toast>
</tt-card>
<!-- '<div class="form-group im-no-mar" ng-show="model.showUpload === true">' +
    '<div class="col-xs-12 sp-0">' +
        '<input name="files" type="file" id="{{model.iId}}" kendo-upload k-options="uploadOptions"></input>' +
        '<div ng-show="model.isTxt === true">' +
            '<br>' +
            '<im-input-directive label="encoding" field="model.encodings.selected" type="select" data="model.encodings.data" dataid="item_id" dataname="item_name"></im-input-directive>' +
            '<im-input-directive label="filecontent" field="model.dataJSON" type="textarea" typevar="r"></im-input-directive>' +
        '</div>' +
    '</div>' +
'</div>' +
'<im-button-directive name="readingdata" spin="model.dataReading" glyphs="fa fa-refresh" btnstyle="btn-warning" btnsize="col-xs-12 im-no-pad" ng-show="model.dataReading === true"></im-button-directive>' +
'<div class="col-xs-12 im-no-pad" ng-show="model.hasData">' +
    '<div id="{{model.mId}}" style="width: 100%;" kendo-spreadsheet ' +
        'k-scope-field="spreadsheet" ' +
        'k-options="spreadsheetOptions">' +
    '</div>' +
    '<br>' +
    '<im-button-directive name="saveasexcel" optionfunc="saveAsExcel()" glyphs="fa fa-file-excel-o" btnstyle="btn-success" btnsize="col-xs-12 im-no-pad" ng-show="model.showUpload === false"></im-button-directive>' +
'</div>', -->
